import { APP_CONFIG } from "./appConfig";

export const APP_KIND = APP_CONFIG.kind;

const envApiBase = import.meta.env.VITE_API_BASE;
export const API_BASE_URL =
  envApiBase !== undefined && envApiBase !== ""
    ? envApiBase
    : import.meta.env.MODE === "development"
      ? APP_CONFIG.devApiBaseUrl
      : APP_CONFIG.prodApiBaseUrl;

const envStoragePrefix = import.meta.env.VITE_APP_STORAGE_PREFIX;
export const STORAGE_PREFIX =
  envStoragePrefix !== undefined ? envStoragePrefix : APP_CONFIG.storagePrefix;

export const getApiAssetUrl = (path) => `${API_BASE_URL}${path}`;
